import bensonImg from "../../assets/team/benson.jpg";
import christyImg from "../../assets/team/christy.jpg";
import annaImg from "../../assets/team/anna.jpg";
import anaghaImg from "../../assets/team/anagha.jpg";
import aswinImg from "../../assets/team/aswin.jpg";
import archanaImg from "../../assets/team/archana.jpg";
import gokulImg from "../../assets/team/gokul.jpg";
import astonImg from "../../assets/team/aston.jpeg";
import ayyappanImg from "../../assets/team/ayyappan.jpg";
import amalImg from "../../assets/team/amal.jpg";
import hariImg from "../../assets/team/hari.jpg";
import hod from "../../assets/team/satheesh-sir.jpeg";
import sundar from "../../assets/team/sundar-sir.jpeg";
import manishankar from "../../assets/team/manishankar-sir.jpg";

const teamData = [
  {
    img: gokulImg,
    name: "Gokul Gopinath",
    role: "Lead Organizer",
  },
  {
    img: archanaImg,
    name: "Archana Sivadasan",
    role: "Lead Organizer",
  },
  {
    img: aswinImg,
    name: "Aswin Santhosh",
    role: "Event Operations Manager",
  },
  {
    img: hariImg,
    name: "Harikrishnan M R",
    role: "Event Operations Manager"
  },
  {
    img: anaghaImg,
    name: "Anagha Saseendran",
    role: "Activities and Event Planner",
  },
  {
    img: astonImg,
    name: "Aston Raju",
    role: "Activities and Event Planner",
  },
  {
    img: annaImg,
    name: "Anna Rose Joshy",
    role: "Activities and Event Planner",
  },
  {
    img: bensonImg,
    name: "Benson Davis",
    role: "Technical Manager",
  },
  {
    img: christyImg,
    name: "Christy Vinny",
    role: "Media Specialist",
  },
  {
    img: ayyappanImg,
    name: "Aswin Ayyappadas",
    role: "Sponsorship Coordinator",
  },
  {
    img: amalImg,
    name: "Amal Yousaf",
    role: "Sponsorship Coordinator",
  },
];


const facultyData = [
  {
    img: hod,
    name: "Dr. R Satheesh Kumar",
    role: "HOD",
  },
  {
    img: sundar,
    name: "Sundar R",
    role: "Faculty",
  },
  {
    img: manishankar,
    name: "Dr. Manishankar",
    role: "Faculty",
  },
];

export {teamData, facultyData};